import { jsx as o, jsxs as w } from "react/jsx-runtime";
import { f as y, m as _, n as A } from "../../vendor--aJiswR_.js";
import { createContext as C, forwardRef as d, useContext as N } from "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as l } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as u } from "../BaseIcon/index.js";
import { DotProgress as P } from "../DotProgress/index.js";
import { AriaBanner as $ } from "./aria/Banner.js";
import '../../assets/index2.css';const R = "_banner_1lov8_1", j = "_sm_1lov8_14", I = "_md_1lov8_20", k = "_success_1lov8_27", z = "_info_1lov8_33", O = "_warning_1lov8_39", V = "_error_1lov8_45", D = "_global_1lov8_51", E = "_actionButton_1lov8_61", F = "_dismissButton_1lov8_62", G = "_body_1lov8_96", t = {
  banner: R,
  sm: j,
  md: I,
  success: k,
  info: z,
  warning: O,
  error: V,
  global: D,
  actionButton: E,
  dismissButton: F,
  body: G
}, L = {
  success: { icon: "checkmark-circle", color: "green" },
  info: { icon: "lightbulb-info", color: "blue" },
  warning: { icon: "warning", color: "sienna" },
  error: { icon: "warning", color: "red" },
  global: { icon: "info" }
}, f = C(null);
function S() {
  const e = N(f);
  if (!e)
    throw new Error("Banner.* components must be used within a <Banner> component.");
  return e;
}
const T = d(function({ children: n, size: s, isDismissible: a = !0, ...r }, i) {
  const c = r.variant ?? "info", B = c === "global" ? "md" : s ?? "md", b = y(t.banner, t[B], t[c]), { icon: g, color: m } = L[c], v = r.isVisible !== void 0;
  return /* @__PURE__ */ o(
    $,
    {
      ref: i,
      ...l(r),
      className: b,
      "data-component": "Banner",
      children: ({ dismiss: h, dismissButtonProps: x }) => /* @__PURE__ */ w(
        f.Provider,
        {
          value: {
            dismiss: h,
            isControlled: v
          },
          children: [
            /* @__PURE__ */ o(u, { icon: g, color: m, mr: 3, ml: 3 }),
            n,
            a && /* @__PURE__ */ o(
              _,
              {
                ...l(x),
                className: t.dismissButton,
                slot: null,
                children: /* @__PURE__ */ o(u, { icon: "close", color: m })
              }
            )
          ]
        }
      )
    }
  );
}), p = d(function({ children: n }, s) {
  return /* @__PURE__ */ o("div", { ref: s, className: t.body, children: n });
}), q = d(
  function(n, s) {
    const { dismiss: a, isControlled: r } = S(), i = (c) => {
      n.onPress?.(c), r || a();
    };
    return typeof n.href == "string" ? /* @__PURE__ */ o(
      A,
      {
        ...l(n),
        className: t.actionButton,
        slot: null,
        onPress: i,
        ref: s,
        children: n.children
      }
    ) : /* @__PURE__ */ o(
      _,
      {
        ...l(n),
        className: t.actionButton,
        slot: null,
        onPress: i,
        ref: s,
        children: n.isPending ? /* @__PURE__ */ o(P, { "aria-label": n.isPendingAriaLabel }) : n.children
      }
    );
  }
), Y = Object.assign(T, {
  Body: p,
  Action: q
});
export {
  Y as Banner
};
//# sourceMappingURL=index.js.map
